// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-n_fL","advertDetailServiceList__header":"c-n_fM","advertDetailServiceList__list":"c-n_fN"};